export default __webpack_public_path__ + "static/media/Image3.6153faff.png";